"use client";

import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";  // Biểu tượng Circle từ Lucide React

import { cn } from "../../lib/utils";  // Hàm cn để kết hợp các lớp CSS

// RadioGroup component
const RadioGroup = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <RadioGroupPrimitive.Root
        className={cn("grid gap-2", className)}  // Lớp CSS cho RadioGroup
        {...props}
        ref={ref}
      />
    );
  }
);

RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

// RadioGroupItem component
const RadioGroupItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
          "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      >
        <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
          <Circle className="size-2.5 fill-current text-current" /> {/* Biểu tượng vòng tròn */}
        </RadioGroupPrimitive.Indicator>
      </RadioGroupPrimitive.Item>
    );
  }
);

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

// Xuất các thành phần để sử dụng trong các phần khác của ứng dụng
export { RadioGroup, RadioGroupItem };
